<template>
  <div>
    <div class="bg-white flex justify-center w-full flex-nowrap pt-5 pb-1">
      <div class="mx-5 w-6/24">
        <Classify></Classify>
      </div>
      <div class="flex-shrink w-full">
        <Carousel :banners="bannerImgs"></Carousel>
      </div>
      <div class="mx-5 w-7/24">
        <Flight></Flight>
      </div>
    </div>
    <div class="default" v-if="newProducts && newProducts.items && newProducts.items.length">
      <!-- <NewList :img="require('@/assets/image/广告1.png')" :span="5" :data="newProducts" @current="paging" :total="total" :goUrl="newProductsLink"> -->
      <NewList :img="newProductsImg" :span="5" :data="newProducts" @current="paging" :total="total"
        :goUrl="newProductsLink">
        <template #title>{{ $t("新品类") }}</template>
      </NewList>
    </div>
    <div class="default" v-if="hotProducts && hotProducts.items && hotProducts.items.length">
      <!-- <List :img="require('@/assets/image/广告2.png')" :span="5" :data="hotProducts"> -->
      <List :img="hotProductsImg" :span="5" :data="hotProducts" :goUrl="newProductsLink">
        <template #title>{{ $t("热卖商品") }}</template>
      </List>
    </div>
    <!-- <div class="default">
      <List :img="recProductsImg" :span="5" :data="recProducts" :goUrl="recProductsLink">
        <template #title>{{ $t("推荐") }}</template>
      </List>
    </div> -->
    <div class="default" v-if="showOrigin">
      <!-- <List :img="require('@/assets/image/广告3.png')" :span="5" :data="recProducts"> -->
      <List :img="normalProductsImg" :span="5" :data="normalProducts" :goUrl="normalProductsLink">
        <template #title>{{ $t("现货") }}</template>
      </List>
    </div>
    <div class="default">
      <!-- <List :img="require('@/assets/image/广告3.png')" :span="5" :data="recProducts"> -->
      <List :img="presellProductsImg" :span="5" :data="presellProducts" :query="{ wh: 'presell' }"
        :goUrl="presellProductsLink">
        <template #title>{{ $t("预售-CIF") }}</template>
      </List>
    </div>
    <div class="bottom" v-if="hotList">
      <!-- 热门资讯 -->
      <hotInformation :data="hotList"></hotInformation>
    </div>
  </div>
</template>

<script>
import Carousel from "@/components/home/carousel";
import Classify from "@/components/home/classify";
import Flight from "@/components/home/flight";
import List from "@/components/home/list";
import NewList from "@/components/home/newlist";
import hotInformation from "@/components/home/hotInformation";
import { onMounted, ref, computed, watch } from "@vue/composition-api";
import Login from "../../components/home/login.vue";
export default {
  components: { Carousel, Classify, Flight, List, NewList, hotInformation },
  setup(props, ctx) {

    const total = ref();

    const getProductLists = async (size, orderby, page, wh, param) => {
      let data = Object.assign({}, param, {size, orderby, page, wh})
      let res = await ctx.root.$callapi('getProductList', data)
      if (res.code == 0 && res.data) {
        return res.data
      }
    }
    const getLeftImg = async () => {
      // 获取首页左侧图片及跳转链接
      console.log(11123232)
      let res = await ctx.root.$callapi('getIndexLeftImg')
      console.log(78686)
      if (res.code == 0 && res.data) {
        let resData = res.data
        if (resData.newproducts) {
          newProductsImg.value = resData.newproducts[0]?.img
          newProductsLink.value = resData.newproducts[0]?.link
        }

        if (resData.hotproducts) {
          hotProductsImg.value = resData.hotproducts[0]?.img
          hotProductsLink.value = resData.hotproducts[0]?.link
        }

        if (resData.recproducts) {
          recProductsImg.value = resData.recproducts[0]?.img
          recProductsLink.value = resData.recproducts[0]?.link
        }
        if (resData.normalproducts) {
          normalProductsImg.value = resData.normalproducts[0]?.img
          normalProductsLink.value = resData.normalproducts[0]?.link
        }

        if (resData.presellproducts) {
          presellProductsImg.value = resData.presellproducts[0]?.img
          presellProductsLink.value = resData.presellproducts[0]?.link
        }
        if (resData.pc_index_banner?.length) {
          bannerImgs.value = resData.pc_index_banner
        }
      }
    }
    const newProducts = ref()
    const hotProducts = ref()
    const recProducts = ref()
    const normalProducts = ref()
    const presellProducts = ref()
    const newProductsImg = ref('')
    const hotProductsImg = ref('')
    const recProductsImg = ref('')
    const newProductsLink = ref('')
    const hotProductsLink = ref('')
    const recProductsLink = ref('')
    const normalProductsImg = ref('')
    const presellProductsImg = ref('')
    const normalProductsLink = ref('')
    const presellProductsLink = ref('')
    const bannerImgs = ref([])
    const user = computed(() => {
      return ctx.root.$store.getters.user;
    })
    const isLoad = ref(false)
    onMounted(async () => {
      isLoad.value = true
      await loadData()
      isLoad.value = false
      await getLeftImg()

    })
/*************  ✨ Windsurf Command ⭐  *************/
    /**
     * @description: 获取首页数据
     * @return {*}
     */
/*******  34f4832c-e201-4e16-aae6-bad42060aaca  *******/
    const loadData = async () => {
      await getProductCount()
      newProducts.value = await getProductLists(5, '', 1, '', {'q__flags__icontains': "[new]"})
      hotProducts.value = await getProductLists(10, '', 1, '', {'q__flags__icontains': "[hot]"})
      // recProducts.value = await getProductLists(10, '-updated')
      if (showOrigin.value) {
        normalProducts.value = await getProductLists(10, '', 1, 'origin')
      }
      presellProducts.value = await getProductLists(10, '', 1, 'presell')

    }
    watch(() => user.value.user_lock_address, async (newVal, oldVal) => {
      if (isLoad.value) return
      ctx.root.$doing()
      await loadData()
      ctx.root.$done()
    })
    const paging = async (value) => {
      newProducts.value = await getProductLists(5, '', value, '', {'q__flags__icontains': "[new]"})
      total.value = newProducts.value.total;
    };
    const hotList = ref();
    onMounted(async () => {
      const res = await ctx.root.$callapi("news/getNewsList", {
        page: 1,
        size: 15,
      });
      hotList.value = res.data;
    });

    const showOrigin = ref(true)
    const getProductCount = async () => {
      let res = await ctx.root.$callapi('getProductCount')
      if (res.code == 0 && res.data) {
        if (res.data.origin == 0) {
          showOrigin.value = false
        } else {
          showOrigin.value = true
        }
      }
    }


    return {
      paging,
      total,
      hotList,
      newProducts,
      hotProducts,
      recProducts,
      newProductsImg,
      hotProductsImg,
      recProductsImg,
      newProductsLink,
      hotProductsLink,
      recProductsLink,
      normalProducts,
      presellProducts,
      normalProductsLink,
      normalProductsImg,
      presellProductsImg,
      presellProductsLink,
      bannerImgs,
      showOrigin
    };
  },
};
</script>
<style scoped lang="scss">
.default {
  @apply mt-12;
}
</style>
